// Vendors
import React from 'react';
// Components
import { CancelDropModalComponent } from 'components/cancel-drop-modal/cancel-drop-modal.component';
// Constants
import { ERROR_MODAL_COMPONENT_PROPS } from './constants/error-modal.constants';
// Types
import { ErrorModalComponentType } from './types/error-modal.type';

const ErrorModalComponent = ({
  handleTrackOpenErrorModal: onOpenModal,
  handleTrackCancelButtonErrorModal,
  handleTrackCloseIconErrorModal,
  onClose,
  showModal,
}: ErrorModalComponentType): React.JSX.Element => (
  <CancelDropModalComponent
    {...{
      ...ERROR_MODAL_COMPONENT_PROPS,
      showModal,
      onOpenModal,
      onClose: () => {
        handleTrackCloseIconErrorModal();
        onClose();
      },
      onLinkClose: () => {
        handleTrackCancelButtonErrorModal();
        onClose();
      },
    }}
  />
);

export { ErrorModalComponent };
